import { EngineService } from './engine.service';
import { TimerangeModel } from './models/animation/timerange.model';
import { plainToClass } from 'class-transformer';
import { get } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "./engine.service";
export class AnimationService {
    constructor(engineService) {
        this.engineService = engineService;
    }
    getChapterLocalTimerange(chapterId) {
        const chapter = Human.timeline.activeRoot._chapters.find(_chapter => _chapter.id === chapterId);
        return plainToClass(TimerangeModel, chapter.timeRange);
        // Human.timeline.activeRoot._nowBranch;
        // get branch timeline:               <branch>.getTimeframe()
        // convert local to globalTime:       Human.timeline.activeRoot.mapBranchTime(<branch>, 1);
        // scrub animation using globalTime:  Human.timeline.scrub(globalTime):  
    }
    mapGlobalTimeToLocal(time, params = {}) {
        return Human.timeline.activeRoot.mapGlobalTime(time, params);
    }
    mapLocalTimeToGlobal(chapterId, time) {
        const branch = Human.timeline.activeRoot._chapters.find(chapter => chapter.id === chapterId);
        return Human.timeline.activeRoot.mapBranchTime(branch, time);
    }
    isChapterAnimated(chapter) {
        const isAnimated = chapter.timelineMap
            .filter(timeline => {
            return get(timeline, 'data.timeline') !== 'dummy' &&
                get(timeline, 'data.timeline.id') !== 'dummy' &&
                get(timeline, 'data.timeline.id.id') !== 'dummy';
        }).length > 0;
        return isAnimated;
    }
    scrub(options) {
        const which = options.which ? options.which : 'first';
        Human.timeline.scrub({
            time: options.time,
            borderCondition: {
                which: which,
                direction: 'forward'
            }
        });
    }
    getTimeFrame() {
        return Human.timeline.getTimeFrame();
    }
    getTime() {
        return Human.timeline.time;
    }
    isPlaying() {
        return Human.timeline.playing;
    }
    play(options) {
        // spread props, but filter any that are undefined.
        // The engine does `hasOwnProperty` checks, so `undefined` params can slip through the cracks if not careful
        const playParams = Object.keys(options).reduce((acc, option) => {
            if (acc[option] === undefined) {
                delete acc[option];
            }
            return acc;
        }, Object.assign({}, options));
        Human.timeline.play(playParams);
    }
    unpause() {
        Human.timeline.unpause();
    }
    pause() {
        Human.timeline.pause();
    }
}
AnimationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnimationService_Factory() { return new AnimationService(i0.ɵɵinject(i1.EngineService)); }, token: AnimationService, providedIn: "root" });
